export const GetMean = (values) => {
    let total = 0
    values.forEach(val => {
        total += val
    });
    return total / values.length
}

export const GetStandardDeviation = (values) => {
    const mean = GetMean(values)
    let sumOfSquaredDeviations = 0
    values.forEach(val => {
        sumOfSquaredDeviations += ((val - mean) * (val - mean))
    })
    return Math.sqrt(sumOfSquaredDeviations / values.length)
}
export const GetMedian = (values) => {
    values.sort((a, b) => a - b);
    const middleIndex = Math.floor(values.length / 2);

    if (values.length % 2 === 0) {
        return (values[middleIndex - 1] + values[middleIndex]) / 2;
    } else {
        return values[middleIndex];
    }
}

export const GetPerformancePercentile = (data, field, percentile_field_name, is_inverse) => {
    const unscoredData = data.filter(x => x[field] == null)
    const dataPoints = data.filter(x => x[field] != null)
    const mean = GetMean(dataPoints.map(x => x[field]))
    const standardDeviation = GetStandardDeviation(dataPoints.map(x => x[field]))

    dataPoints.map(dp => dp[percentile_field_name] = (is_inverse ? (1 - GetZPercent((dp[field] - mean) / standardDeviation)).toFixed(2) : GetZPercent((dp[field] - mean) / standardDeviation).toFixed(2)))
    unscoredData.map(ud => ud[percentile_field_name] = .5)
    return unscoredData.concat(dataPoints)
}

export const GetZPercent = (z) =>
{
    //z == number of standard deviations from the mean

    //if z is greater than 6.5 standard deviations from the mean
    //the number of significant digits will be outside of a reasonable 
    //range
    if ( z < -6.5)
      return 0.0;
    if( z > 6.5) 
      return 1.0;

    var factK = 1;
    var sum = 0;
    var term = 1;
    var k = 0;
    var loopStop = Math.exp(-23);
    while(Math.abs(term) > loopStop) 
    {
        term = .3989422804 * Math.pow(-1,k) * Math.pow(z,k) / (2 * k + 1) / Math.pow(2,k) * Math.pow(z,k+1) / factK;
        sum += term;
        k++;
        factK *= k;

    }
    sum += 0.5;

    return sum;
}

export const FormatFloatAsDollarAmount = (value) => {
    return "$" + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}